<template>
  <div id="_sponsors">
    <div class="header-block">
    <info-block :title="$getModuleTitle(currentEvent.modules, 'Sponsors')" :desc="$t('networking.description')" :button="null" :url="null"></info-block>

    </div>
    <Nodata :title="$getModuleTitle(currentEvent.modules, 'Sponsors')" :description="categoryId == null && searchTerm == null && searchTerm != '' ? $t('contentNotFound') : $t('contentFilterNotFound')" anim="holacon-sponsors-lottie" :loading="$store.state.eventLoading == 'sponsors'" v-if="currentSponsorCategories.length == 0" :button="$t('refresh')" @btnClick="$store.dispatch('getSponsors', { id: currentEvent.id, route: false })" />

    <div class="sponsors-wrapper" v-for="category in currentSponsorCategories" v-else :key="category.id">
      <h3 class="sponsor-title">{{ category.title }}<span :style="'background-color: ' + currentEvent.color"></span></h3>
      <div class="sponsor-item">
        <div class="sponsor-image" @click="openURL(item)" v-for="item in currentSponsors.filter(k => k.categoryID == category.id)" :key="item.id" :style="'width: calc(' + getLogoScale(category.logoScale) + '% - 30px); cursor:' + (item.externalLink != '' && item.externalLink != null ? 'pointer' : 'initial')">
          <md-tooltip md-delay="100"> {{ item.title }} </md-tooltip>
          <img :src="$imageus + item.image + '?width=800&height=800&mode=contain&background=ffffff'" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import InfoBlock from "../../modules/InfoBlock";

export default {
  name: "SponsorsComponent",
  components: {
    InfoBlock
  },
  mounted() {
    this.width = document.getElementById("_sponsors").clientWidth;
    this.$nextTick(() => {
      this.$store.dispatch("getSponsorCategories", { id: this.currentEvent.id, route: false });
      this.$store.dispatch("getSponsors", { id: this.currentEvent.id, route: false });
    });
  },
  data() {
    return {
      categoryId: null,
      searchTerm: null,
      width: 0
    };
  },
  methods: {
    getLogoScale(scale) {
      if (this.width < 768) {
        return scale * (100 / 100);
      }
      return scale * (120 / 220);
    },
    openURL(url) {
      if (url.externalLink != "" && url.externalLink != null) {
        window.open(url.externalLink);
      }
    }
  },
  computed: {
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    currentSponsors() {
      return this.$store.getters.getSponsors;
    },
    currentSponsorCategories() {
      return this.$store.getters.getSponsorCategories;
    }
  }
};
</script>

<style lang="less">
#_sponsors {
  font-family: "Roboto", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  .header-block {
    width:100%;
  }
  .sponsors-wrapper {
    width: 100%;

    .sponsor-title {
      text-align: center;
      width: 100%;
      font-size: 18px;
      border-bottom: 0.5px solid #d6d9d9;
      background: unset;
      min-height: 54px;
      height: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;
      align-items: center;
      gap: 10px;
      padding-bottom:6px;

      span {
        width: 15%;
        height: 6px;
        border-radius: 3px;
        position: absolute;
        margin: 0 auto;
        bottom: -3px;
      }
    }

    .sponsor-item {
      width: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      gap: 8px;
      justify-content: center;
    }

    .sponsor-image {
      display: flex;
      align-items: center;
      justify-content: center;
      background-position: center;
      box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);

      background-size: contain;
      background-repeat: no-repeat;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      padding: 5px;
      img {
        border-radius: 8px;
      }
      background: #ffffff;
      border-radius: 12px;
      transition: all 0.3s ease 0s;
      &:hover {
        transition: all 0.3s ease 0s;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/event/Sponsors.vue